import { render } from "./UserManageBoschID.vue?vue&type=template&id=44cbdb35&scoped=true"
import script from "./UserManageBoschID.vue?vue&type=script&lang=js"
export * from "./UserManageBoschID.vue?vue&type=script&lang=js"

import "./UserManageBoschID.vue?vue&type=style&index=0&id=44cbdb35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cbdb35"]])

export default __exports__